import { Label } from '@acpaas-ui/react-components';
import sanitizeHtml from 'sanitize-html';

const OfferingDetailView = ({ children, title, themes, description, images = [] }) => {
  return (
    <div className="spo-o-offering-detail-view">
      {themes?.map((t, i) => (
        <Label key={`${t}_${i}`} className="u-margin-bottom-xs u-margin-right-sm" type="primary">
          {t}
        </Label>
      ))}
      <div
        className="u-margin-top-sm"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(description)?.replace(/<a/gm, '<a target="_blank"') ?? '' }}
      ></div>
      {children}
      {images?.map((i) => (
        <img key={i} className="u-margin-top-sm" src={i} alt={`${title}`} width="100%" />
      ))}
    </div>
  );
};

export default OfferingDetailView;
